import { useEffect } from "react";
import { pageTitle, imgUrl } from "../../helper";
import PageHeading from "../PageHeading";
import Div from "../Div";
import SectionHeading from "../SectionHeading";
import Spacing from "../Spacing";

export default function AboutPage() {
  pageTitle("About");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* Start Page Heading Section */}
      <PageHeading
        title="About Us"
        bgSrc="/images/about_hero_bg.jpeg"
        pageLinkText="About Us"
      />
      {/* End Page Heading Section */}

      {/* Start About Section */}
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-xl-5 col-lg-7 about-overview">
            <SectionHeading
              title="An Entertainment Group Built to Operate."
              subtitle="About Dreamscript"
            >
              <Spacing lg="30" md="20" />
              <p className="cs-m0">
                Dreamscript was founded to build and scale long-term
                entertainment platforms. We focus on gaming, interactive
                entertainment and telecom-integrated ecosystems where
                intellectual property, structured distribution and disciplined
                monetization work together as one system. Our platforms are
                designed to operate across markets, evolve with audience
                behavior and maintain long-term relevance.
              </p>
              <Spacing lg="15" md="15" />
              <Div className="cs-m0">
                <ul>
                  <li>We think in infrastructure.</li>
                  <li>We execute in product.</li>
                  <li>We think in infrastructure.</li>
                  <li>We scale through distribution.</li>
                </ul>
              </Div>
              <Spacing lg="30" md="30" />
              <Spacing lg="25" md="40" />
            </SectionHeading>
          </Div>
          <Div className="col-lg-5 offset-xl-2 about-img">
            <img
              src={imgUrl("/images/about_img_1.jpeg")}               alt="About"
              className="w-100 cs-radius_15"
            />
            <Spacing lg="25" md="25" />
          </Div>
          <Div className="col-lg-7 cs-hidden_mobile other-img">
            <img
              src={imgUrl("/images/about_img_2.jpeg")}               alt="About"
              className="w-100 cs-radius_15"
            />
            <Spacing lg="25" md="25" />
          </Div>
          <Div className="col-lg-5 cs-hidden_mobile other-img">
            <img
              src={imgUrl("/images/about_img_3.jpeg")}               alt="About"
              className="w-100 cs-radius_15"
            />
            <Spacing lg="25" md="25" />
          </Div>
        </Div>
      </Div>
      <Spacing lg="75" md="55" />
      {/* End About Section */}

      {/* Start Why Choose Section */}
      <Spacing lg="100" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-xl-5 col-lg-6">
            <Div className="cs-image_layer cs-style1">
              <Div className="cs-image_layer_in">
                <img
                  src={imgUrl("/images/about_img_4.jpeg")}                   alt="About"
                  className="w-100 cs-radius_15"
                />
              </Div>
            </Div>
            <Spacing lg="0" md="40" />
          </Div>
          <Div className="col-xl-5 offset-xl-1 col-lg-6">
            <SectionHeading
              title="Highly experienced people with us"
              subtitle="Why Choose Us"
            >
              <Spacing lg="30" md="20" />
              <p className="cs-m0">
                Unlike traditional studios or investment vehicles, Dreamscript
                combines platform creation, carrier integration and operational
                ownership under one structure. We build with intention, deploy
                with discipline and operate with long-term accountability.
              </p>
              <Spacing lg="15" md="15" />

              <Div className="cs-separator cs-accent_bg"></Div>
              <Spacing lg="25" md="0" />
            </SectionHeading>
          </Div>
        </Div>
      </Div>
      {/* End Why Choose Section */}
    </>
  );
}
